import { Col, Row } from "reactstrap";
import "./contactUs.css";
import contactImg from "../../assests/images/contactus.webp";
function ContactUs() {
  return (
    <Row className="contact_wrap_genric">
      <Col md="5" className="contactus_wrapper mt-5 pt-5">
        <h1>Get in touch</h1>

        <p className="para_contact_para">
          Welcome to Minimalist. Our goal is to provide not just exceptional
          products, but also exceptional service. <br /> <br /> For any
          questions or queries, listed below are ways in which you can reach us.
          <br /> <br />
          <b>Email:</b>
          <a href="mailto:yazdaniaquib2@gmail.com">yazdaniaquib2@gmail.com</a>
        </p>
      </Col>
      <Col md="7" className="contactus_wrapper ">
        <div className="blog_img_wrapper">
          <img
            width={"100%"}
            height={"100%"}
            src={contactImg}
            alt="contact us"
          />
        </div>
      </Col>
    </Row>
  );
}

export default ContactUs;
